
import { Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useLanguage } from "@/components/LanguageContext";

interface StudentLoginFormProps {
  formData: {
    email: string;
    password: string;
  };
  isSubmitting: boolean;
  onFormChange: (key: string, value: string) => void;
  onSubmit: (e: React.FormEvent) => void;
  onToggleForm: () => void;
}

export const StudentLoginForm = ({
  formData,
  isSubmitting,
  onFormChange,
  onSubmit,
  onToggleForm
}: StudentLoginFormProps) => {
  const { t } = useLanguage();
  
  return (
    <form onSubmit={onSubmit} className="space-y-4">
      <div className="space-y-2">
        <Label htmlFor="email">{t('auth.login.emailLabel')}</Label>
        <Input
          id="email"
          type="email"
          placeholder={t('auth.login.emailPlaceholder')}
          value={formData.email}
          onChange={(e) => onFormChange("email", e.target.value)}
          required
        />
      </div>
      <div className="space-y-2">
        <Label htmlFor="password">{t('auth.login.passwordLabel')}</Label>
        <Input
          id="password"
          type="password"
          value={formData.password}
          onChange={(e) => onFormChange("password", e.target.value)}
          required
        />
      </div>
      <Button type="submit" className="w-full" disabled={isSubmitting}>
        {isSubmitting ? (
          <Loader2 className="h-4 w-4 animate-spin" />
        ) : (
          t('auth.login.submitButton')
        )}
      </Button>
      <div className="mt-4 text-center text-sm">
        <Button
          variant="link"
          onClick={onToggleForm}
          className="text-xs"
        >
          {t('publicProfile.noAccount')}
        </Button>
      </div>
    </form>
  );
};
